import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3996056d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3996056d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996056d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3996056d')) {
      api.createRecord('3996056d', component.options)
    } else {
      api.reload('3996056d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3996056d&scoped=true&", function () {
      api.rerender('3996056d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/sheet-to-review/components/AxlePagination/index.vue"
export default component.exports